module.exports = __webpack_public_path__ + "img/image_3-995e105c.png";